<template>
  <main class="main common_apply_list" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="sub_main">
        <div class="h_tab">
          <ul>
            <li class="on">
              <button>인터넷</button>
            </li>
            <li>
              <button @click="goLink('Mobile.ApplyList')">휴대폰</button>
            </li>
          </ul>
        </div>
        <div class="n_suggest" id="main_con">
          <div class="regi_application">
            <div class="round_filter tp">
              <ul>
                <li @click="selectSort">
                  <button>{{ isSortText }}</button>
                </li>
              </ul>
            </div>
            <ApplyList
              v-if="list.length > 0"
              :is-customer="isCustomer"
              :list="list"
              @review="goToReview"
              @review-write="goToReviewWrite"
              @shop-detail="goShopDetail"
              @apply-detail="goApplyDetail"
              @enter-chat="enterChatRoom"
              @goReportStore="goReportStore"
              @goGuaranteeConfirm="goGuaranteeConfirm"
              @popupView="popupView"
              @viewInfoPopup="viewInfoPopup"
            />

            <div
              class="list_progress_none"
              v-if="internetCommerceApplyList.pagination.totalElements == 0"
            >
              <p>
                신청내역이 없습니다!<br />
                HOME 화면에서 나에게 맞는 상품을 찾아보세요!
              </p>
              <button @click="goLink('InternetCommerce.Main')">
                HOME으로 가기
              </button>
            </div>
          </div>
          <infinite-loading
            ref="infiniteLoading"
            :direction="direction"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <span slot="no-more"></span>
            <span slot="no-results"></span>
            <span slot="spinner"></span>
          </infinite-loading>
        </div>
      </div>
    </div>

    <SortModal :show="isSortOpen" @close="sortModalClose" ref="sortModal" />

    <InternetApplyPopup
      :show="isShowPopup"
      :step="isStep"
      :item="selItem"
      ref="internetApplyPopup"
      @review-write="goToReviewWrite"
      @close="internetApplyPopupClose"
    ></InternetApplyPopup>

    <DesignPopup2
      :show="isViewInfoPopup"
      :data="{
        title: '설치예정일 수정',
        type: 'confirm',
        msg: msg,
        btn_1: '취소',
        btn_2: '변경하기',
      }"
      @close="vieInfoPopupClose"
    />
  </main>
</template>
<script>
import ApplyList from '@common/components/internetCommerce/ApplyList';
import SortModal from '@/front/customer/views/internetApply/modal/SortModal';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import InfiniteLoading from 'vue-infinite-loading';

import InternetApplyPopup from '@/common/components/internetCommerce/modal/InternetApplyPopup';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import { sleep } from '@common/lib/common/utils';

export default {
  components: {
    ApplyList,
    SortModal,
    InfiniteLoading,
    InternetApplyPopup,
    DesignPopup2,
  },
  data() {
    return {
      selApplyId: 0,
      isTab_1: true,
      isTab_2: false,
      isCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      isSortOpen: false,
      isSortText: '최신 순',
      isSortRealText: '',
      isSearchSort: 'CREATED_AT_DESC', // CREATED_AT_ASC , CREATED_AT_DESC

      visitPage: 0,
      scrollLocation: 0,
      isVisitName: [
        'Shops.Detail',
        'InternetCommerce.ApplyForm',
        'InternetCommerce.ApplyDetail',
        'chat.room',
        'Mobile.ApplyList',
        'Shops.WriteReview',
        'Shops.Reviews',
        'chat.report',
        'InternetCommerce.GuaranteeConfirm',
      ], // 뒤로 이동시 가능한 방문 페이지 정리
      isShowPopup: false,
      isStep: '',
      selItem: {},
      isViewInfoPopup: false,
      msg:
        '<img src="' +
        require('@/assets/front/images/v2/img_cal.png') +
        '" style="width:5.1rem;height:5rem;text-align:center;display:inline-block;margin-bottom:1rem;" /><div style="color:#212121;font-size: 1.4rem;margin-bottom:1rem;text-align:center;">설치기사님과 일정 조율 후<br />작성하신 설치희망일에서 날짜 변동이 있었나요?</div><div style="border-radius:1.2rem;background-color:#f3f3f3;color:#212121;padding:0.8rem;margin-bottom:1rem;text-align:center;font-size: 1.4rem;">설치희망일 기준 4일 이내에 답변을 주시면,<br />지원금을 받지 못하셨을때 퍼스가 신속하게 도와 드릴 수 있어요!</div><div style="color:#212121;font-size:1.4rem;margin-bottom:1rem;text-align:center;">안전한 보장을 위해<br />설치희망일 다음날에 알림톡을 보내드리니</div><div style="color:#212121;font-size:1.6rem;text-align:center;font-weight:700;">변경된 설치일을 꼭 알려주세요!</div>',
    };
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  async created() {
    this.isCompleted = true;
  },
  async mounted() {
    // 페이징 뒤로가기 설정 시작
    this.page = 1;
    if (this.visitPage > 0) {
      for (var i = 0; i < this.visitPage - 1; i++) {
        this.infiniteId += 1;
      }
    } else {
      this.infiniteId += 1; //리스트 가져오기.
    }
    // 페이징 뒤로가기 설정 끝
  },
  computed: {
    ...internetMapGetters({
      internetCommerceApplyList: internetTypes.INTERNET_COMMERCE_APPLY_LIST,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  methods: {
    ...internetMapActions([internetTypes.SELECT_INTERNET_COMMERCE_APPLY_LIST]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.CREATE_CHATROOM,
    ]),
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_internet_apply_list',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;
          this.isSearchSort = visit_page.isSearchSort;

          if (this.isSearchSort == 'CREATED_AT_DESC') {
            this.isSortText = '최신 순';
          } else {
            this.isSortText = '오래된 순';
          }

          // 데이터 담고 삭제
          await localStorage.removeItem('visit_internet_apply_list');
        }
      }
    },
    setVisitPage() {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      const target = document.querySelector('#main_con');
      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치

      const visit_page = {
        scrollLocation: scrollLocation,
        isSearchSort: this.isSearchSort,
        page: this.page,
      };

      localStorage.setItem(
        'visit_internet_apply_list',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.searchInternetCommerceApplyList();

        if (this.page == 1) {
          this.list = [];
        }

        console.log('this.internetCommerceApplyList');
        console.log(this.internetCommerceApplyList);

        if (this.internetCommerceApplyList.content.length) {
          this.list.push(...this.internetCommerceApplyList.content);

          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async searchInternetCommerceApplyList() {
      const params = {
        orderType: this.isSearchSort,
        page: this.page,
        size: this.size,
      };
      await this[internetTypes.SELECT_INTERNET_COMMERCE_APPLY_LIST](params);
    },
    selectSort() {
      this.isSortOpen = true;
    },
    async sortModalClose(checked) {
      if (checked) {
        const target = document.querySelector('#main_con');
        this.isSortText = this.$refs.sortModal.selectSort;
        this.isSortRealText = this.$refs.sortModal.selectSortReal;

        this.isSearchSort = this.isSortRealText;

        await this.getListPageOne();
        target.scrollTo(0, 0);
      }

      this.isSortOpen = false;
    },
    goShopDetail(storeId) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: storeId,
        },
      });
    },
    goApplyDetail(applyId) {
      this.setVisitPage();
      this.$router.push({
        // name: 'InternetCommerce.ApplyForm',
        // params: {
        //   id: applyId,
        //   mode: 'detail',
        // },
        name: 'InternetCommerce.ApplyDetail',
        params: {
          id: applyId,
          title: '인터넷 가입 신청서',
        },
      });
    },
    async enterChatRoom(storeId) {
      this.setVisitPage();
      this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      });

      let name = 'chat.room';
      const params = {};
      if (this.chatroom_with.count == 0) {
        // name = 'chat.room.create';
        // params.storeId = storeId;
        this[chatActions.CREATE_CHATROOM]({
          chatRoomType: 'OneOnOne',
          memberId: '',
          storeId: storeId,
          estimateId: undefined,
        }).then(() => {
          console.log('this.chatroom');
          console.log(this.chatroom);
          params.uuid = this.chatroom.uuid;
          params.createRoom = 'Y';

          this.$router.push({
            name,
            params,
          });
        });
      } else {
        params.uuid = this.chatroom_with.content[0].uuid;
        this.$router.push({
          name,
          params,
        });
      }
    },
    async selectTab(sel) {
      if (sel == 1) {
        this.isTab_1 = true;
        this.isTab_2 = false;
      } else {
        this.isTab_1 = false;
        this.isTab_2 = true;
      }
    },
    goToReview(item) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: item.storeId },
        query: { type: 'internet' },
      });
    },
    goToReviewWrite(item) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.WriteReview',
        params: { id: item.storeId },
        query: { type: 'internet' },
      });
    },
    goLink(link) {
      this.setVisitPage();
      this.$router.push({
        name: link,
      });
    },
    goReportStore(item) {
      this.setVisitPage();
      this.$router.push({
        name: 'chat.report',
        query: {
          applyId: item.id,
          name: item.store.storeName,
        },
      });
    },
    goGuaranteeConfirm(confirmType, applyId) {
      this.setVisitPage();
      this.$router.push({
        name: 'InternetCommerce.GuaranteeConfirm',
        query: { confirmType: confirmType, applyId: applyId },
      });
    },
    popupView(step, item) {
      this.isShowPopup = true;
      this.$refs.internetApplyPopup.$refs.apply_con.style.height = '90vh';

      this.isStep = step;
      this.selItem = item;
    },
    internetApplyPopupClose() {
      this.isShowPopup = false;
    },
    viewInfoPopup(applyId) {
      this.selApplyId = applyId;
      this.isViewInfoPopup = true;
    },
    vieInfoPopupClose(val) {
      if (val) {
        this.goGuaranteeConfirm('CHANGE', this.selApplyId);
      }
      this.isViewInfoPopup = false;
    },
  },
};
</script>
